module.exports = __webpack_public_path__ + "static/img/12.53f37ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/12.jpg
// module id = L9h+
// module chunks = 0